export type MonitoringAction = 'start' | 'stop' | 'pause' | 'resume';

export interface MonitoringActionOptions {
    resumeDate?: number;
    /** Quickstart id for 'start' — selected via the phase-selection step inside ManageMonitoringModal. */
    quickstart?: string;
}

type MonitoringStateBucket = 'active' | 'paused' | 'stopped' | 'not-started' | 'unknown';

interface StatusDisplay {
    label: string;
    pillClass: string;
}

const STATUS_BUCKET_DISPLAY: Record<MonitoringStateBucket, StatusDisplay> = {
    active: { label: 'Active', pillClass: 'bg-green-50 text-green-700' },
    paused: { label: 'Paused', pillClass: 'bg-yellow-50 text-yellow-700' },
    stopped: { label: 'Stopped', pillClass: 'bg-gray-100 text-gray-500' },
    'not-started': { label: 'Not started', pillClass: 'bg-gray-100 text-gray-500' },
    unknown: { label: 'Unknown', pillClass: 'bg-gray-100 text-gray-500' }
};

// DM's raw status enum is "unstarted" | "started" | "paused" | "stopped", with
// "resumed" appearing from the Monday.com sync path — treated the same as
// "started" everywhere else in the app (IconsRow, MonitoringCard), so it is
// folded into "active" here too.
function getMonitoringStateBucket(rawStatus: string | null | undefined): MonitoringStateBucket {
    const status = (rawStatus ?? '').toLowerCase();
    if (status === 'started' || status === 'resumed') return 'active';
    if (status === 'paused') return 'paused';
    if (status === 'stopped') return 'stopped';
    if (status === 'unstarted') return 'not-started';
    return 'unknown';
}

export function getStatusDisplay(rawStatus: string | null | undefined): StatusDisplay {
    return STATUS_BUCKET_DISPLAY[getMonitoringStateBucket(rawStatus)];
}

export function getAvailableActions(rawStatus: string | null | undefined): MonitoringAction[] {
    const bucket = getMonitoringStateBucket(rawStatus);
    if (bucket === 'active') return ['pause', 'stop'];
    if (bucket === 'paused') return ['resume', 'stop'];
    if (bucket === 'not-started' || bucket === 'stopped') return ['start'];
    return [];
}
